import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Building2, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface StepBusinessInfoProps {
  onNext: (data: {
    businessName: string;
    category: string;
    description: string;
  }) => void;
  onBack: () => void;
}
export function StepBusinessInfo({
  onNext,
  onBack
}: StepBusinessInfoProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      onNext({
        businessName,
        category,
        description
      });
    }, 1000);
  };
  return <div className="space-y-6" data-id="element-468">
      <div className="text-center space-y-2" data-id="element-469">
        <div className="mx-auto w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4" data-id="element-470">
          <Building2 className="w-8 h-8 text-teal-600" data-id="element-471" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-472">Business Profile</h2>
        <p className="text-gray-500" data-id="element-473">Tell us a bit about your business</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5 mt-8" data-id="element-474">
        <Input label="Business Name" placeholder="e.g. Acme Corp" value={businessName} onChange={e => setBusinessName(e.target.value)} required data-id="element-475" />

        <Input label="Category" placeholder="e.g. Retail, Service, Food" value={category} onChange={e => setCategory(e.target.value)} required data-id="element-476" />

        <div className="space-y-2" data-id="element-477">
          <label className="block text-sm font-medium text-gray-700" data-id="element-478">
            Description
          </label>
          <textarea className="block w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500/20 transition-all duration-200 min-h-[100px]" placeholder="Brief description of your business..." value={description} onChange={e => setDescription(e.target.value)} data-id="element-479" />
        </div>

        <div className="pt-4 flex gap-3" data-id="element-480">
          <Button type="button" variant="secondary" onClick={onBack} className="flex-1" data-id="element-481">
            Back
          </Button>
          <Button type="submit" variant="primary" className="flex-[2]" isLoading={isLoading} data-id="element-482">
            Next Step <ArrowRight className="ml-2 w-5 h-5" data-id="element-483" />
          </Button>
        </div>
      </form>
    </div>;
}